module.exports = __webpack_public_path__ + "static/media/batyr.2f419213.png";